import React, { useEffect, useState } from "react";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const DailyInvestment = () => {
  const [data, setData] = useState([]);

  // Fetch or set your data here (this could come from an API or static data)
  useEffect(() => {
    const fetchedData = [
      { date: '2023-04-01', usersJoined: 12 },
      { date: '2023-04-02', usersJoined: 3 },
      { date: '2023-04-03', usersJoined: 5 },
      { date: '2023-04-04', usersJoined: 17 },
      { date: '2023-04-05', usersJoined: 22 },
      { date: '2023-04-06', usersJoined: 8 },
      { date: '2023-04-07', usersJoined: 13 },
      { date: '2023-04-08', usersJoined: 31 },
      { date: '2023-04-09', usersJoined: 5 },
      { date: '2023-04-10', usersJoined: 7 },
    ];
    setData(fetchedData); // Set the data from an API or static array
  }, []);

  // Prepare the chart data dynamically based on the fetched data
  const chartData = {
    labels: data.map((item) => item.date), // x-axis labels (dates)
    datasets: [
      {
        // label: 'Daily Investment in USDT',
        data: data.map((item) => item.usersJoined),
        backgroundColor: '#a500ed', // Bar color
        borderRadius: 4, // Rounded corners for bars
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      title: {
        display: false,
        text: 'Users Joined per Day',
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw} USDT`, // Customize the tooltip to show the number of users
        },
      },
      legend: {
        display: false, // Hide legend since we removed the label
      },
    },
    scales: {
      x: {
        title: {
          display: false,
          text: 'Date',
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 10, // Limit the number of ticks on the x-axis to avoid overlap
        },
      },
      y: {
        title: {
          display: true,
          text: 'Daily Investment in USDT',
        },
        beginAtZero: true, // Start y-axis at zero
      },
    },
  };

  return (
    <>
      <Bar data={chartData} options={options} />
    </>
  );
};

export default DailyInvestment;
